// @flow

import React, { type Node, useState, useMemo } from 'react';
import { FormStatusContext } from './context';
import { type FormStatus } from './types';

type Props = {|
  children: Node,
|};

export function FormStatusContextProvider({ children }: Props): Node {
  const [formStatus, setFormStatus] = useState<FormStatus>('initial');

  const providedFormStatusContext = useMemo(() => {
    return [formStatus, setFormStatus];
  }, [formStatus, setFormStatus]);

  return (
    <FormStatusContext.Provider value={providedFormStatusContext}>
      {children}
    </FormStatusContext.Provider>
  );
}
